import { r as f, n as p, t as y } from "./-chunk-@lit.js";
import { x as v } from "./-chunk-lit-html.js";
import { r as A } from "./-chunk-lit-element.js";
import { C as S } from "./-cart-api.js";
function w() {
  try {
    const t = sessionStorage.getItem("gwp_removed");
    return t ? JSON.parse(t) : [];
  } catch {
    return [];
  }
}
function C(t) {
  try {
    t.length === 0 ? sessionStorage.removeItem("gwp_removed") : sessionStorage.setItem("gwp_removed", JSON.stringify(t));
  } catch (e) {
    console.error("Error setting removed GWP offers:", e);
  }
}
function m() {
  return new Promise((t) => {
    const e = () => {
      const s = document.querySelector(".mini-cart__overlay");
      s != null && s.classList.contains("loading") ? setTimeout(e, 200) : t();
    };
    e();
  });
}
async function b(t) {
  const e = S.getInstance(), r = (await e.getCart()).items.filter((o) => t.includes(o.key)), i = {};
  r.forEach((o) => {
    i[o.key] = 0;
  }), await e.updateCart({ updates: i });
}
var T = Object.defineProperty, I = Object.getOwnPropertyDescriptor, l = (t, e, s, r) => {
  for (var i = r > 1 ? void 0 : r ? I(e, s) : e, o = t.length - 1, n; o >= 0; o--)
    (n = t[o]) && (i = (r ? n(e, s, i) : n(i)) || i);
  return r && i && T(e, s, i), i;
};
let h = class extends A {
  constructor() {
    super(), this.currentDiscountId = "", this.shouldAutoAdd = !1, this.autoAddProducts = "", this.shouldAutoRemove = !1, this.shouldAutoOpenScreen = !1, this.itemsToRemove = "", this.giftQuantity = 1, this.giftsInCart = 0, this.tierThreshold = 0, this.tierId = null, this.discountSubtotals = "", this.isOpen = !0, this.isScreenOpen = !1, this.currentScreenId = null, this.selectedProducts = {}, this.isAutoAdding = !1, this.isAutoRemoving = !1, this.previousTierId = null, this.thresholdCache = /* @__PURE__ */ new Map(), this.discounts = [], this.cartTotal = 0, this.lastDiscountSubtotals = "", this.lastCartTotal = 0, this.discountSubtotalsMap = {}, this.handleClick = async (t) => {
      var s, r;
      const e = t.target;
      if (e.closest("[data-gwp-toggle]")) {
        this.toggleWidget();
        return;
      }
      if (e.closest("[data-add-gift]")) {
        const i = (s = e.closest("[data-add-gift]")) == null ? void 0 : s.getAttribute("data-screen-id"), o = (r = e.closest("[data-add-gift]")) == null ? void 0 : r.getAttribute("data-discount-id");
        if (i && o) {
          await this.checkEligibility(o) && await this.openScreen(i, o);
          return;
        }
      }
      if (e.closest("[data-close-screen]")) {
        this.closeScreen();
        return;
      }
      if (e.closest("[data-add-product]")) {
        this.handleAddProduct(e);
        return;
      }
      if (e.closest("[data-remove-product]")) {
        this.handleRemoveProduct(e);
        return;
      }
      if (e.closest("[data-update-cart]")) {
        this.handleUpdateCart();
        return;
      }
    }, this.handleCartUpdate = () => {
      this.clearThresholdCache(), this.initState();
    }, this._openDrawerTimeout = null, this.cartApi = S.getInstance(), this.discounts = [], this.cartTotal = 0, this.initState();
  }
  connectedCallback() {
    super.connectedCallback(), this.shouldAutoAdd = this.getAttribute("data-should-auto-add") === "true", this.autoAddProducts = this.getAttribute("data-auto-add-products") || "", this.shouldAutoRemove = this.getAttribute("data-should-auto-remove") === "true", this.itemsToRemove = this.getAttribute("data-items-to-remove") || "", this.giftQuantity = parseInt(this.getAttribute("data-gift-quantity") || "1"), this.giftsInCart = parseInt(this.getAttribute("data-gifts-in-cart") || "0"), this.shouldAutoOpenScreen = !1, this.tierThreshold = parseInt(this.getAttribute("data-tier-threshold") || "0"), this.tierId = this.getAttribute("data-tier-id"), this.discountSubtotals = this.getAttribute("data-discount-subtotals") || "", this.initDiscounts(), this.initializeEventListeners(), this.checkAndManageTiers(), this.shouldAutoOpenScreen = !1, this.tierThreshold > 0 && this.checkAndAutoOpenScreen().then((t) => t), document.addEventListener("click", (t) => {
      var s;
      const e = t.target.closest("cart-remove-button");
      if (e) {
        const r = e.closest(".cart-item");
        if (r) {
          const i = (s = r.querySelector("[data-gwp-discount-id]")) == null ? void 0 : s.getAttribute("data-gwp-discount-id");
          if (i) {
            const o = w();
            o.includes(i) || this.setRemovedGWPOffers([...o, i]);
          }
        }
      }
    }), this.shouldAutoAdd && this.currentDiscountId && this.autoAddProducts && (w().includes(this.currentDiscountId) || this.tryAutoAddGWP(this.currentDiscountId));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListeners();
  }
  initDiscounts() {
    this.discountSubtotalsMap = {}, this.discountSubtotals && this.discountSubtotals.split(",").forEach((t) => {
      const [e, s] = t.split(":");
      e && s && (this.discountSubtotalsMap[e] = parseInt(s, 10));
    }), this.discounts = window.gwpOffers.sort((t, e) => t.threshold - e.threshold).map((t, e, s) => {
      const r = t.id;
      return {
        id: r,
        threshold: t.threshold * 100,
        subtotal: this.discountSubtotalsMap[r]
      };
    });
  }
  // INITIALIZE STATE
  async initState() {
    const t = await this.getCart(), e = (t == null ? void 0 : t.items) || [];
    if (this.querySelectorAll(".gwp-widget__screen").forEach((r) => {
      const i = r.getAttribute("data-discount-id");
      if (!i) return;
      (!this.isScreenOpen || this.currentScreenId !== `gwp-widget-${i}`) && (this.selectedProducts[i] = {}, e.forEach((n) => {
        var c, a;
        if ((c = n.properties) != null && c._gwp && ((a = n.properties) == null ? void 0 : a._gwp_discount_id) === i) {
          const d = n.variant_id.toString();
          this.selectedProducts[i][d] = n.quantity;
        }
      })), r.querySelectorAll(".gwp-widget__product-card").forEach((n) => {
        var d;
        const c = n.getAttribute("data-product-id"), a = n.querySelector("[data-buttons-block]");
        if (c && a) {
          const u = !!((d = this.selectedProducts[i]) != null && d[c]);
          a.classList.toggle("added", u), this.updateButtonStates(i, c, a);
        }
      });
    }), t && (this.initDiscounts(), (this.discountSubtotals !== this.lastDiscountSubtotals || t.total_price !== this.lastCartTotal) && (this.cartTotal = t.total_price, this.lastDiscountSubtotals = this.discountSubtotals, this.lastCartTotal = t.total_price, this.discountSubtotalsMap = {}, this.discountSubtotals && this.discountSubtotals.split(",").forEach((r) => {
      const [i, o] = r.split(":");
      i && o && (this.discountSubtotalsMap[i] = parseInt(o, 10));
    }), this.discounts.forEach((r) => this.checkThreshold(r.id)))), !sessionStorage.getItem("gwp_drawer_closed_once")) {
      let r = this.discounts.find(
        (i) => this.checkThreshold(i.id) && !w().includes(i.id)
      );
      !r && this.discounts.length > 0 && (r = this.discounts[0]), r && (this.currentDiscountId = r.id, this.shouldAutoOpenScreen = !1, this.checkAndAutoOpenScreen());
    }
  }
  // INITIALIZE EVENT LISTENERS
  initializeEventListeners() {
    this.addEventListener("click", this.handleClick), document.addEventListener("cart-updated", this.handleCartUpdate), document.addEventListener("click", async (t) => {
      const e = t.target.closest(".cart-item__edit-button");
      if (e) {
        const s = e.getAttribute("data-gwp-discount-id");
        s && this.checkThreshold(s) && (this.currentDiscountId = s, this.openScreen(`gwp-widget-${s}`, s));
      }
    });
  }
  // REMOVE EVENT LISTENERS
  removeEventListeners() {
    this.removeEventListener("click", this.handleClick), document.removeEventListener("cart-updated", this.handleCartUpdate);
  }
  // TOGGLE WIDGET
  toggleWidget() {
    this.isOpen = !this.isOpen, this.updateWidgetVisibility();
  }
  // OPEN SCREEN
  async openScreen(t, e) {
    this.isScreenOpen = !0, this.currentScreenId = t, this.currentDiscountId = e, this.updateScreenVisibility();
    const s = await this.getCart(), r = (s == null ? void 0 : s.items) || [];
    this.selectedProducts[e] = {}, r.forEach((i) => {
      var o, n;
      if ((o = i.properties) != null && o._gwp && ((n = i.properties) == null ? void 0 : n._gwp_discount_id) === e) {
        const c = i.variant_id.toString();
        this.selectedProducts[e][c] = i.quantity;
      }
    }), this.refreshScreenButtonStates(e), this.initState();
  }
  // CLOSE SCREEN
  closeScreen() {
    this.isScreenOpen = !1, this.currentScreenId = null, this.currentDiscountId = "", this.shouldAutoOpenScreen = !1, sessionStorage.setItem("gwp_drawer_closed_once", "true"), this.updateScreenVisibility();
  }
  // UPDATE WIDGET VISIBILITY
  updateWidgetVisibility() {
    const t = this.querySelector(".gwp-widget__container"), e = this.querySelector(".gwp-widget__open-button");
    t && e && (t.classList.toggle("closed", !this.isOpen), e.classList.toggle("hidden-button", this.isOpen));
  }
  // UPDATE SCREEN VISIBILITY
  updateScreenVisibility() {
    this.querySelectorAll(".gwp-widget__screen").forEach((e) => {
      const s = e.getAttribute("data-discount-id"), r = `gwp-widget-${s}`, i = this.isScreenOpen && this.currentScreenId === r && this.currentDiscountId === s;
      e.classList.toggle("active", i);
    });
  }
  refreshScreenButtonStates(t) {
    const e = this.querySelector(`.gwp-widget__screen[data-discount-id="${t}"]`);
    if (!e) return;
    e.querySelectorAll(".gwp-widget__product-card").forEach((r) => {
      var n;
      const i = r.getAttribute("data-product-id"), o = r.querySelector("[data-buttons-block]");
      if (i && o) {
        const c = !!((n = this.selectedProducts[t]) != null && n[i]);
        o.classList.toggle("added", c), this.updateButtonStates(t, i, o);
      }
    });
  }
  // UPDATE BUTTON STATES
  updateButtonStates(t, e, s) {
    var d;
    if (!s) return;
    const r = s.querySelector(".add-to-cart-block__general-button-added-text");
    if (r) {
      const u = ((d = this.selectedProducts[t]) == null ? void 0 : d[e]) || 0;
      u > 0 ? r.textContent = `Added (${u})` : r.textContent = "Added";
    }
    const i = this.getScreenLimit(t), o = this.selectedProducts[t] || {}, n = Object.values(o).reduce((u, g) => u + g, 0), c = this.querySelector(`.gwp-widget__screen[data-discount-id="${t}"]`), a = c == null ? void 0 : c.querySelectorAll(".add-to-cart-block__plus-button");
    a && a.forEach((u) => {
      u.classList.toggle("disabled", n >= i);
    }), this.checkScreenLimits(t);
  }
  // ADD PRODUCT - General and Plus buttons
  handleAddProduct(t) {
    var n, c;
    const e = t.getAttribute("data-variant-id") || ((n = t.closest("[data-add-product]")) == null ? void 0 : n.getAttribute("data-variant-id")), s = (c = t.closest(".gwp-widget__screen")) == null ? void 0 : c.getAttribute("data-discount-id"), r = t.closest("[data-buttons-block]");
    if (!e || !s) return;
    this.selectedProducts[s] || (this.selectedProducts[s] = {});
    const i = this.selectedProducts[s][e] || 0, o = this.getScreenLimit(s);
    i >= o || (this.selectedProducts[s][e] = i + 1, r && this.toggleTargetClass(r, "added", !0), this.updateButtonStates(s, e, r), this.requestUpdate());
  }
  // REMOVE PRODUCT - Minus button
  handleRemoveProduct(t) {
    var o;
    const e = t.getAttribute("data-variant-id"), s = (o = t.closest(".gwp-widget__screen")) == null ? void 0 : o.getAttribute("data-discount-id"), r = t.closest("[data-buttons-block]");
    if (!e || !s) return;
    const i = this.selectedProducts[s][e] || 0;
    i > 0 && (this.selectedProducts[s][e] = i - 1), this.selectedProducts[s][e] == 0 && this.toggleTargetClass(r, "added", !1), this.updateButtonStates(s, e, r), this.requestUpdate();
  }
  // UPDATE CART - Done button
  async handleUpdateCart() {
    if (!this.currentDiscountId) return;
    const t = S.getInstance(), s = (await t.getCart()).items || [], r = Object.entries(this.selectedProducts[this.currentDiscountId] || {}).map(([i, o]) => {
      const n = {
        _gwp: "true",
        _gwp_discount_id: this.currentDiscountId,
        _gwp_tier_threshold: this.getCurrentTierThreshold(this.currentDiscountId).toString()
      };
      return {
        id: i,
        quantity: o,
        properties: n
      };
    });
    if (r.length === 0) {
      this.closeScreen();
      return;
    }
    try {
      const i = {}, o = [];
      if (document.dispatchEvent(new CustomEvent("cart:loading")), r.forEach((n) => {
        const c = s.find(
          (a) => {
            var d, u;
            return a.variant_id.toString() === n.id && ((d = a.properties) == null ? void 0 : d._gwp) === "true" && ((u = a.properties) == null ? void 0 : u._gwp_discount_id) === this.currentDiscountId;
          }
        );
        c ? i[c.key] = n.quantity : o.push(n);
      }), s.forEach((n) => {
        var c, a;
        ((c = n.properties) == null ? void 0 : c._gwp) === "true" && ((a = n.properties) == null ? void 0 : a._gwp_discount_id) === this.currentDiscountId && (r.some(
          (u) => u.id === n.variant_id.toString()
        ) || (i[n.key] = 0));
      }), Object.keys(i).length > 0 && await t.updateCart({ updates: i }), o.length > 0) {
        await t.addToCart(o);
        const n = o[o.length - 1];
        await this.showGiftNotification(n.id);
      }
      await this.checkAndManageTiers(), window.__CART__ = await t.getCart(), this.initState(), document.dispatchEvent(new CustomEvent("cart:loaded")), this.closeScreen(), sessionStorage.removeItem("gwp_drawer_closed_once");
    } catch (i) {
      console.error("Error updating cart:", i), document.dispatchEvent(new CustomEvent("cart:loaded"));
    }
  }
  async showGiftNotification(t) {
    var o;
    const e = this.querySelector(`.gwp-widget__product-card[data-product-id="${t}"]`);
    if (!e) return;
    const s = (o = e.querySelector("img")) == null ? void 0 : o.src;
    if (!s) return;
    const r = document.querySelector(".gift-cart-notification");
    if (!r) return;
    const i = r.querySelector("img");
    i && (i.src = s), r.setAttribute("style", "display: flex;"), setTimeout(() => {
      r.setAttribute("style", "display: none;");
    }, 3e3);
  }
  // CHECK SCREEN LIMITS
  checkScreenLimits(t) {
    const e = this.querySelector(`.gwp-widget__screen[data-discount-id="${t}"]`);
    if (!e) return !1;
    const s = e.getAttribute("data-discount-id"), r = e.getAttribute("data-limit"), i = e.querySelector("[data-added-products-count]");
    if (!s || !r) return;
    const o = this.selectedProducts[s] || {}, n = Object.values(o).reduce((c, a) => c + a, 0);
    n >= parseInt(r) ? this.toggleTargetClass(e, "full-limit", !0) : this.toggleTargetClass(e, "full-limit", !1), i && (i.textContent = n.toString(), i.setAttribute("data-added-products-count", n.toString()));
  }
  // GET SCREEN LIMIT
  getScreenLimit(t) {
    const e = this.querySelector(`.gwp-widget__screen[data-discount-id="${t}"]`);
    return e ? parseInt(e.getAttribute("data-limit") || "0") : 0;
  }
  setRemovedGWPOffers(t) {
    C(t);
  }
  toggleTargetClass(t, e, s) {
    t && t.classList.toggle(e, s);
  }
  checkThreshold(t) {
    const e = this.discounts.find((r) => r.id === t);
    return e ? (e.subtotal ?? 0) >= e.threshold : !1;
  }
  clearThresholdCache() {
    this.thresholdCache.clear();
  }
  // Get the subtotal for a given discountId from this.discounts
  getDiscountSubtotal(t) {
    const e = this.discounts.find((s) => s.id === t);
    return typeof (e == null ? void 0 : e.subtotal) == "number" ? e.subtotal : 0;
  }
  // Get the threshold for a given discountId from this.discounts
  getCurrentTierThreshold(t) {
    if (this.tierThreshold !== 0)
      return this.tierThreshold;
    const e = t || this.currentDiscountId, s = this.discounts.find((r) => r.id === e);
    return typeof (s == null ? void 0 : s.threshold) == "number" ? s.threshold : 0;
  }
  async checkAndManageTiers() {
    const t = await this.getCart();
    if (!t)
      return;
    const e = this.itemsToRemove;
    if (e.length) {
      this.dispatchEvent(new CustomEvent("cart:loading")), await b(e.split(",").map((i) => i)), this.dispatchEvent(new CustomEvent("cart:loaded"));
      return;
    }
    let s = null, r = -1 / 0;
    for (const i of this.discounts)
      this.checkThreshold(i.id) && i.threshold > r && (s = i.id, r = i.threshold);
    if (s) {
      const i = this.getCurrentTierThreshold(s), o = t.items.filter((n) => {
        var a;
        if (!((a = n.properties) != null && a._gwp)) return !1;
        const c = n.properties._gwp_discount_id;
        return c !== s ? this.getCurrentTierThreshold(c) < i : !1;
      });
      o.length && (this.dispatchEvent(new CustomEvent("cart:loading")), await b(o.map((n) => n.key)), this.currentDiscountId = s), await this.tryAutoAddGWP(s), this.dispatchEvent(new CustomEvent("cart:loaded"));
    }
    s && (this.currentDiscountId = s, this.shouldAutoAdd = !0);
  }
  async tryAutoAddGWP(t) {
    if (!this.checkThreshold(t))
      return;
    const e = this.querySelector(`.gwp-widget__screen[data-discount-id="${t}"]`);
    if (!e)
      return;
    const s = parseInt(e.getAttribute("data-limit") || "0");
    if (!s)
      return;
    const r = await this.getCart(), i = r.items.reduce((d, u) => {
      var g, _;
      return (g = u.properties) != null && g._gwp && ((_ = u.properties) == null ? void 0 : _._gwp_discount_id) === t ? d + u.quantity : d;
    }, 0);
    if (i >= s)
      return;
    if (w().includes(t)) {
      await m();
      return;
    }
    const n = e.querySelectorAll(".gwp-widget__product-card");
    if (n.length !== 1) {
      i < s && await m();
      return;
    }
    const c = n[0].getAttribute("data-product-id");
    if (!c) {
      await m();
      return;
    }
    if (!r.items.find(
      (d) => {
        var u, g;
        return d.variant_id.toString() === c && ((u = d.properties) == null ? void 0 : u._gwp) && ((g = d.properties) == null ? void 0 : g._gwp_discount_id) === t;
      }
    )) {
      this.dispatchEvent(new CustomEvent("cart:loading"));
      try {
        await S.getInstance().addToCart([{
          id: c,
          quantity: 1,
          properties: {
            _gwp: "true",
            _gwp_discount_id: t,
            _gwp_tier_threshold: this.getCurrentTierThreshold(t).toString()
          }
        }]);
      } catch (d) {
        console.error("Error auto-adding GWP:", d), await m();
      } finally {
        this.dispatchEvent(new CustomEvent("cart:loaded"));
      }
    }
  }
  openGWPDrawer(t) {
    this._openDrawerTimeout && clearTimeout(this._openDrawerTimeout), this._openDrawerTimeout = setTimeout(async () => {
      if (this.getCurrentTierThreshold(t) <= 0) {
        this._openDrawerTimeout = null, this.closeScreen();
        return;
      }
      if (!await this.checkEligibility(t)) {
        this._openDrawerTimeout = null, this.closeScreen();
        return;
      }
      this.currentDiscountId = t, this.openScreen(`gwp-widget-${t}`, t), this._openDrawerTimeout = null;
    }, 100);
  }
  getCart() {
    return this.cartApi.getCart();
  }
  async checkAndAutoOpenScreen() {
    if (this.isScreenOpen && this.currentScreenId === `gwp-widget-${this.currentDiscountId}`)
      return;
    if (!this.shouldAutoOpenScreen || !this.currentDiscountId) {
      this.closeScreen();
      return;
    }
    if (!await this.checkEligibility(this.currentDiscountId)) {
      this.closeScreen();
      return;
    }
  }
  async checkEligibility(t) {
    if (!t || !this.checkThreshold(t))
      return !1;
    const e = this.querySelector(`.gwp-widget__screen[data-discount-id="${t}"]`);
    if (!e) return !1;
    const s = parseInt(e.getAttribute("data-limit") || "0");
    if (!s) return !1;
    const r = await this.getCart();
    return r ? r.items.reduce((o, n) => {
      var c, a;
      return (c = n.properties) != null && c._gwp && ((a = n.properties) == null ? void 0 : a._gwp_discount_id) === t ? o + n.quantity : o;
    }, 0) < s : !1;
  }
  render() {
    return v`<slot></slot>`;
  }
};
l([
  p({ type: String, attribute: "data-current-discount" })
], h.prototype, "currentDiscountId", 2);
l([
  p({ type: Boolean, attribute: "data-should-auto-add" })
], h.prototype, "shouldAutoAdd", 2);
l([
  p({ type: String, attribute: "data-auto-add-products" })
], h.prototype, "autoAddProducts", 2);
l([
  p({ type: Boolean, attribute: "data-should-auto-remove" })
], h.prototype, "shouldAutoRemove", 2);
l([
  p({ type: Boolean, attribute: "data-should-auto-open-screen" })
], h.prototype, "shouldAutoOpenScreen", 2);
l([
  p({ type: String, attribute: "data-items-to-remove" })
], h.prototype, "itemsToRemove", 2);
l([
  p({ type: Number, attribute: "data-gift-quantity" })
], h.prototype, "giftQuantity", 2);
l([
  p({ type: Number, attribute: "data-gifts-in-cart" })
], h.prototype, "giftsInCart", 2);
l([
  p({ type: Number, attribute: "data-tier-threshold" })
], h.prototype, "tierThreshold", 2);
l([
  p({ type: String, attribute: "data-tier-id" })
], h.prototype, "tierId", 2);
l([
  p({ type: String, attribute: "data-discount-subtotals" })
], h.prototype, "discountSubtotals", 2);
l([
  f()
], h.prototype, "isOpen", 2);
l([
  f()
], h.prototype, "isScreenOpen", 2);
l([
  f()
], h.prototype, "currentScreenId", 2);
l([
  f()
], h.prototype, "selectedProducts", 2);
l([
  f()
], h.prototype, "isAutoAdding", 2);
l([
  f()
], h.prototype, "isAutoRemoving", 2);
l([
  f()
], h.prototype, "previousTierId", 2);
h = l([
  y("gwp-widget")
], h);
export {
  h as GWPWidget
};
